import { render, staticRenderFns } from "./eComplaintPDA.vue?vue&type=template&id=61093383"
import script from "./eComplaintPDA.vue?vue&type=script&lang=js"
export * from "./eComplaintPDA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports